import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import './index.css'
import ButtonPurple from 'components/design/Form/ButtonPurple'

const NotificationsLogModal = () => {
  const settings = useSelector(state => state.settings)
  const dispatch = useDispatch()
  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const { visibleModalID } = settings
  const modalID = 'notificationLogs'
  const visible = modalID === visibleModalID
  return (
    <Modal
      className="notifications_log_modal"
      onCancel={handleCancel}
      afterClose={handleCancel}
      open={visible}
      footer={null}
      maskClosable={false}
      zIndex={10000}
    >
      <>
        <div className='logs-modal-content'>
          <div className='logs-enabled-icon-wrapper'>
            <div className='logs-enabled-icon' />
          </div>
          <div className='logs-modal-title'>Logs Enabled Successfully</div>
          <div className="logs-modal-subtitle">
            Notification logs are now active. You can start viewing and managing all sent notifications.
            <div className='logs-modal-subtitle-bold'>
              Note: Logs will automatically disable after 7 days.
            </div>
          </div>
        </div>
        <ButtonPurple holderStyles={{width: '100%'}} buttonStyles={{width: '100%'}} onClick={handleCancel} buttonText="Got it" />
      </>
    </Modal>
  )
}

export default NotificationsLogModal
